import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { Router, RouterLink } from '@angular/router';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-leave',
  standalone: true,
  imports: [LoaderComponent, NgSelectModule, FormsModule, DataTablesModule, CommonModule, RouterLink],
  templateUrl: './admin-leave.component.html',
  styleUrl: './admin-leave.component.scss'
})
export class AdminLeaveComponent {

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  isDisabled: boolean = false;
  user = [] as any;
  Branchs = [];
  Clients = [];
  Sites = [];
  TableDatas = [] as any;

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpCode: '' as any
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private router: Router,
    private toast: ToastService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.ComboLoad('Branch');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'EmpLoadForRegularization') {
            if (this.Filter.BranchId == null) {
              this.toast.show({ message: 'Kindly select atleast Branch', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            if (response.ComboLoad.length == 0) {
              this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            this.TableDatas = response.ComboLoad;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    this.TableDatas = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }
}
